import * as React from 'react';
import { Row, Col, Button, FormGroup, ControlLabel } from 'react-bootstrap';
import { flow } from 'lodash';
import { Field, formValueSelector } from 'redux-form';
import FieldFormControl from '../../../../components/FieldFormControl/index';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import { IStore } from '../../../../redux/IStore';
import FaCheck from 'react-icons/fa/check';
import FaExclamationTriangle from 'react-icons/fa/exclamation-triangle';
import { IQuoteActions, IQuoteState } from '../../../../services/quote/models';

interface IVoucherCodeProps {
  quote: IQuoteState;
  campaignCode: string;
  dispatch: any;
  change: any;
  renderDefinition(name: string): any;
  actions: {
    quote: IQuoteActions;
  };
}

class VoucherCode extends React.Component<IVoucherCodeProps> {
  public componentWillMount() {
    const { quote, actions, dispatch, change } = this.props;
    if (quote.campaignCode) {
      dispatch(change('campaignCode', quote.campaignCode));
      actions.quote.dispatchVoucherCode(quote.campaignCode);
    }
  }

  private checkVoucherCode = () => {
    const { actions, campaignCode } = this.props;

    actions.quote.checkVoucherCode(campaignCode);
  }

  private renderButtonMessage = () => {
    const { quote, channel } = this.props;
    if (quote.voucherCodeStatus === 'success') {
      return <span>{quote.voucherCodeMessage} <FaCheck /></span>;
    }

    if (quote.voucherCodeStatus === 'error') {
      return <span>{quote.voucherCodeMessage} <FaExclamationTriangle /></span>;
    }

    return <span>Apply</span>;
  }

  public render() {
    const { quote } = this.props;

    return (
        <div className="section">
          <FormGroup>
            <Row>
              <Col sm={3}>
                <ControlLabel>
                  Promotional code: {this.props.renderDefinition('promotional_code')}
                </ControlLabel>
              </Col>
              <Col sm={9}>
                <Row>
                  <Col sm={8} className={quote.voucherCodeStatus === 'error' && 'has-error'}>
                    <Field
                      name="campaignCode"
                      placeholder={'Enter your voucher code...'}
                      component={FieldFormControl}
                      disabled={null !== quote.campaignCode}
                    />
                  </Col>
                  <Col sm={4} className={'mobileApply'}>
                    <Button
                      bsStyle={quote.voucherCodeStatus === 'error' ? 'danger' : 'primary'}
                      block={true}
                      onClick={this.checkVoucherCode}
                      disabled={null !== quote.campaignCode}
                    >
                      {this.renderButtonMessage()}
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </FormGroup>
        </div>
    );
  }
}

let selector;

export default flow([
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
connect(
  (state: IStore) => {
    const campaignCode = selector(state, 'campaignCode');

    return {
      quote: state.quote,
      campaignCode,
    };
  },
  (dispatch) => ({
    actions: {
      quote: bindActionCreators({...quoteActions}, dispatch),
    },
  }),
),
])(VoucherCode);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/components/VoucherCode/index.tsx